<form class="modal-image-header">
  <div class="modal-header">
    <span class="modal-title"> Header Image AQUI </span>
    <mat-icon (click)="closeModal(false)">close</mat-icon>
  </div>
  <div class="modal-body">
    <div
      class="content-img"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
    >
      <div class="inputDrag" [ngClass]="{ 'active-drag': isDragActive }">
        <ng-container *ngIf="!isUploading && imgPreview === ''">
          <mat-icon class="mr-2">backup</mat-icon>
          <span>Cargar imagen</span>
        </ng-container>
        <img *ngIf="!isUploading && imgPreview !== ''" [src]="imgPreview" class="max-h-48" alt="" />
        <div *ngIf="isUploading" class="upload-progress">
          <mat-icon>cloud_upload</mat-icon>
          <span>Uploading...</span>
        </div>
        <span *ngIf="uploadError" class="upload-error">{{ uploadError }}</span>
        <input
          type="file"
          accept="image/*"
          class="file-input"
          (change)="onFileSelected($event)"
        />
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn-cancel text-sm"
      data-bs-dismiss="modal"
      (click)="closeModal(false)"
    >
      Cancel
    </button>
    <button
      type="button"
      class="btn-save text-sm"
      data-bs-dismiss="modal"
      (click)="closeModal(true)"
    >
      Save
    </button>
  </div>
</form>
